import { getFormattedNumber } from "./get-formatted-number";

const getFormat: Record<string, (date: string) => string> = {
  "HH:mm": (dateStr) => {
    const date = new Date(dateStr);
    const hours = getFormattedNumber(date.getHours());
    const minutes = getFormattedNumber(date.getMinutes());

    return `${hours}:${minutes}`;
  },
  "HH:mm:ss": (dateStr) => {
    const date = new Date(dateStr);
    const hours = getFormattedNumber(date.getHours());
    const minutes = getFormattedNumber(date.getMinutes());
    const seconds = getFormattedNumber(date.getSeconds());

    return `${hours}:${minutes}:${seconds}`;
  },
};

export const getFormattedTime = (
  date: string,
  format: keyof typeof getFormat = "HH:mm"
): string => getFormat[format](date);
